import { __awaiter } from "tslib";
import * as moment from 'moment';
import { publish } from '@holmescorp/pub-sub';
import svc from './svc';
const _imageObj = new Image();
const data = {
    messages: {},
    learnerName: ''
};
export const load_cert = (params) => {
    data.messages = params.messages;
    data.learnerName = params.learnerName;
    data.canvas = params.canvas;
    data.printNode = params.printNode;
    _imageObj.src = data.messages.background;
};
_imageObj.addEventListener('load', () => {
    const toInt = (v) => (typeof v === 'string' ? parseInt(v, 10) : v);
    const canvas = data.canvas;
    const context = canvas.getContext('2d');
    const bgWidth = toInt(data.messages[`bg_width`]) || 0;
    const bgHeight = toInt(data.messages[`bg_height`]) || 0;
    const portrait = data.messages[`portrait`] === 'true';
    const textAlign = (data.messages[`text_align`] || 'center');
    const nameFont = data.messages[`name_font`] || '32px sans-serif';
    const nameX = toInt(data.messages[`name_x`]) || 0;
    const nameY = toInt(data.messages[`name_y`]) || 0;
    const dateShow = data.messages[`date_show`] === 'true';
    const dateFont = data.messages[`date_font`] || '20px sans-serif';
    const dateX = toInt(data.messages[`date_x`]) || 0;
    const dateY = toInt(data.messages[`date_y`]) || 0;
    if (portrait) {
        canvas.width = bgWidth;
        canvas.height = bgHeight;
    }
    else {
        canvas.width = bgHeight;
        canvas.height = bgWidth;
        context.translate(bgHeight, 0);
        context.rotate((90 * Math.PI) / 180);
    }
    context.drawImage(_imageObj, 0, 0);
    context.textAlign = textAlign;
    context.font = nameFont;
    context.fillText(data.learnerName, nameX, nameY);
    if (dateShow) {
        context.font = dateFont;
        context.fillText(moment().format('l'), dateX, dateY);
    }
    const printNode = data.printNode;
    if (printNode) {
        const printDoc = printNode.contentDocument;
        const newDoc = document.implementation.createHTMLDocument('');
        const certImg = newDoc.createElement('img');
        certImg.src = canvas.toDataURL();
        newDoc.body.appendChild(certImg);
        const style = newDoc.createElement('style');
        const cssText = newDoc.createTextNode('@page {size: letter portrait; margin: 0;} body{margin: .78in .6in;} img{width: 99%;}');
        style.type = 'text/css';
        style.appendChild(cssText);
        newDoc.head.appendChild(style);
        const printEl = newDoc.documentElement;
        const newNode = printDoc.importNode(printEl, true);
        printDoc.replaceChild(newNode, printDoc.documentElement);
        setTimeout(() => {
            publish('cert/loaded');
        }, 1000);
    }
});
export const print_cert = () => {
    const printWin = data.printNode.contentWindow;
    printWin.focus();
    printWin.print();
};
export const check_rpc_passed = (userid) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const postTestData = yield svc.posttest_passed({
        member_id: userid,
        session_id: (_a = window.hcstatic.course_session) === null || _a === void 0 ? void 0 : _a.pk
    });
    return postTestData ? (_b = postTestData['main-menu']) === null || _b === void 0 ? void 0 : _b.passed : false;
});
export const excerpt = (message, length) => {
    const e = document.createElement('div');
    e.innerHTML = message;
    const msg = e.textContent;
    const dots = msg.length > length ? '...' : '';
    return `${msg === null || msg === void 0 ? void 0 : msg.split(/\s+/).join(' ').slice(0, length)}${dots}`;
};
